import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, updateRole } from 'store/data/roles';

type HandlerInput = Parameters<typeof updateRole>;

export function useUpdateRole(): Operation<(...input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.UPDATE_ROLE);

	function handler(...input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(updateRole(...input));
	}

	return [{ loading, error }, handler];
}
